import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ImageModalComponent } from '../../core/image-modal/image-modal.component';
import { MmtVisitDetail, MmtVisitUpdateDetail } from 'src/app/models/mmt.model';
import { AuthService } from 'src/app/services/auth.service';
import { NgForm } from '@angular/forms';
import { HttpMmtService } from 'src/app/services/http-mmt.service';
import { User } from 'src/app/models/core.model';
import { HttpWeedfreeService } from 'src/app/services/http-weedfree.service';

@Component({
  selector: 'app-mmt-visit',
  templateUrl: './mmt-visit.component.html',
  styleUrls: ['./mmt-visit.component.scss']
})
export class MmtVisitComponent implements OnInit {

  visit: MmtVisitDetail;
  photos: string[];

  operatorList: User[] = [];

  get client() {
    return this.auth.client;
  }

  constructor(
    private route: ActivatedRoute,
    private auth: AuthService,
    private http: HttpMmtService,
    private weedfreeHttp: HttpWeedfreeService,
    private modalService: BsModalService
    ) { }

  ngOnInit() {
    this.route.data.subscribe((data: Data) => {
      this.visit = data.visit.visit;
      this.photos = data.visit.photos;
    });

    if (this.auth.client == 1) {
      this.weedfreeHttp.operatorList().subscribe(
        (users: User[]) => {
          this.operatorList = users;
        }
      );
    }
  }

  imageUrl(img: string) {
    // NOTE: these are actually linked via nginx to the shared folder...
    return '/assets/images/mmt/photos/' + this.visit.id + '/' + img;
  }

  onImageClick(img: string) {
    this.modalService.show(ImageModalComponent, { class: 'modal-lg', initialState: { url: this.imageUrl(img) } });
  }

  onSubmitWeedfreeUpdate(form: NgForm) {
    const updateDetail: MmtVisitUpdateDetail = {
      id: this.visit.id,
      purchaseOrder: form.value['purchaseOrder'],
      submittedBy: form.value['submittedBy'],
      site: form.value['site'],
      machine: form.value['machine']
    };

    this.http.updateVisit(updateDetail).subscribe(
      (response: boolean) => {
        console.log(response);
      }
    );
  }
}
